export const CREATE_GAME_PARAM_SESSSION_KEY = 'createGameParam';

export const GAME_PARAM_DEFAULT_VALUE = 0;

export function deepCopy(item) {
  let result;
  try {
    result = JSON.parse(JSON.stringify(item));
  } catch (e) {
    console.log(e);
  }
  return result;
}

/**
 * 游戏内参数配置tab
 */
export enum GameParamTab {
  GameParamTabHero = 0, // 英雄属性
  GameParamTabCreep = 1, // 兵线
  GameParamTabMonster = 2, // 野怪
  GameParamTabTower = 3, // 防御塔
  GameParamTabCrystal = 4, // 水晶
}

/**
 * 游戏内参数配置
 */
export enum GameParamMode {
  GameParamModeStandard = 100000, // 标准模式
  GameParamModeRandom = 5, // 随机抽卡
  GameParamModeCold = 1, // 极速冷却
  GameParamModeSeckill = 2, // 互秒荣耀
  GameParamModeSurvival = 3, // 极限生存
  GameParamModeMaxed = 4, // 一步到位
  GameParamModeCustom = 10000, // 自定义
}

/**
 * 游戏内参数设置方式
 */
export enum GameParamConfigType {
  GameParamConfigTypeGlobal = 1, // 全局统一
  GameParamConfigTypeFaction = 2, // 按阵营
  GameParamConfigTypePlayer = 3, // 按选手
}

export const GAME_PARAM_HERO_CONFIG_TYPE = {
  global: { value: GameParamConfigType.GameParamConfigTypeGlobal, label: '全局统一' },
  faction: { value: GameParamConfigType.GameParamConfigTypeFaction, label: '按阵营' },
  player: { value: GameParamConfigType.GameParamConfigTypePlayer, label: '按选手' },
};

export const GAME_PARAM_NORMAL_CONFIG_TYPE = {
  global: { value: GameParamConfigType.GameParamConfigTypeGlobal, label: '全局统一' },
  faction: { value: GameParamConfigType.GameParamConfigTypeFaction, label: '按阵营' },
};

/**
 * 默认游戏内参数配置选项（自定义选项需要根据状态动态生成）
 */
export const DEFAULT_GAME_PARAM_OPTIONS = [
  { value: GameParamMode.GameParamModeStandard, label: '标准模式', desc: '按照游戏标准对局参数进行游戏' },
  { value: GameParamMode.GameParamModeRandom, label: '随机抽卡', desc: '每位选手获得随机参数加成，互不公开' },
  { value: GameParamMode.GameParamModeCold, label: '极速冷却', desc: '80%冷却缩减，无限火力10人激战' },
  { value: GameParamMode.GameParamModeSeckill, label: '互秒荣耀', desc: '开局5级，伤害强化，冷却缩减，樯橹灰飞烟灭' },
  { value: GameParamMode.GameParamModeSurvival, label: '极限生存', desc: '防御塔和野区全面加强，击杀满30胜利' },
  { value: GameParamMode.GameParamModeMaxed, label: '一步到位', desc: '开局15级12000金币，一步到位决战峡谷' },
];
/**
 * BattleRoom 房间类型
 */
export enum BattleRoomType {
  BattleRoomDefault = 100, // 默认 【赛宝_1.2.7】赛宝主页调整和创建流程改动 后固定为100 （原值：0）
  RandomRecruit5v5 = 1, // 王者峡谷· 随机征召·5v5
  Common5v5 = 2, // 王者峡谷·普通·4v4
  Common4v4 = 3, // 王者峡谷·普通·4v4
  Common3v3 = 4, // 王者峡谷·普通·3v3
  Common2v2 = 5, // 王者峡谷·普通·2v2
  Common1v1 = 6, // 王者峡谷·普通·1v1
  CommonCustomNum =7, // 王者峡谷·普通·自定义人数
}

export const GameParamKey = {
  hero: {
    initialLevel: 'initialLevel',
    magicAttackBonus: 'magicAttackBonus',
    physicalAttackBonus: 'physicalAttackBonus',
    cooldownReduction: 'cooldownReduction',
    initialGold: 'initialGold',
    speed: 'speed',
  },
  creep: {
    creepAttack: 'creepAttack',
    creepHealth: 'creepHealth',
    creepSpeed: 'creepSpeed',
    creepSpawnRate: 'creepSpawnRate',
    creepType: 'creepType',
    creepPath: 'creepPath',
  },
  monster: {
    monsterAttack: 'monsterAttack',
    monsterHealth: 'monsterHealth',
  },
  tower: {
    towerAttack: 'towerAttack',
    towerAttackRange: 'towerAttackRange',
    towerHealth: 'towerHealth',
  },
  crystal: {
    crystalAttack: 'crystalAttack',
    crystalHealth: 'crystalHealth',
    crystalArmor: 'crystalArmor',
  },
  winCondition: {
    winCondition: 'winCondition',
  },
};
/**
 * 随机抽卡buff对应图片
 */
export const HeroParamImg = [
  { key: GameParamKey.hero.initialLevel, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon5.png' },
  { key: GameParamKey.hero.magicAttackBonus, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon4.png' },
  { key: GameParamKey.hero.physicalAttackBonus, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon6.png' },
  { key: GameParamKey.hero.cooldownReduction, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon2.png' },
  { key: GameParamKey.hero.initialGold, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon1.png' },
  { key: GameParamKey.hero.speed, imgUrl: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/gain-icon3.png' },
];

/**
 * 配置key对应的配置表索引
 */
export const GameParamKeyIndexMap = {
  [GameParamKey.hero.initialLevel]: [[0, 51, 56, 61, 66], [28, 71, 76, 81, 86]],
  [GameParamKey.hero.magicAttackBonus]: [[1, 52, 57, 62, 67], [29, 72, 77, 82, 87]],
  [GameParamKey.hero.physicalAttackBonus]: [[2, 53, 58, 63, 68], [30, 73, 78, 83, 88]],
  [GameParamKey.hero.cooldownReduction]: [[3, 54, 59, 64, 69], [31, 74, 79, 84, 89]],
  [GameParamKey.hero.initialGold]: [[4, 55, 60, 65, 70], [32, 75, 80, 85, 90]],
  [GameParamKey.hero.speed]: [[106, 107, 108, 109, 110], [111, 112, 113, 114, 115]],
  [GameParamKey.creep.creepAttack]: [[5], [33]],
  [GameParamKey.creep.creepHealth]: [[6], [34]],
  [GameParamKey.creep.creepSpeed]: [[7], [35]],
  [GameParamKey.creep.creepSpawnRate]: [[8], [36]],
  [GameParamKey.creep.creepType]: [[9], [37]],
  [GameParamKey.creep.creepPath]: [[10], [38]],
  [GameParamKey.monster.monsterAttack]: [[11], [39]],
  [GameParamKey.monster.monsterHealth]: [[12], [40]],
  [GameParamKey.tower.towerAttack]: [[13, 22], [41, 48]],
  [GameParamKey.tower.towerAttackRange]: [[15, 24], [43, 50]],
  [GameParamKey.tower.towerHealth]: [[14, 23], [42, 49]],
  [GameParamKey.crystal.crystalAttack]: [[16], [44]],
  [GameParamKey.crystal.crystalHealth]: [[17], [45]],
  [GameParamKey.crystal.crystalArmor]: [[18], [46]],
};

/**
 * 关联ID，需要设置关联ID为相同的值
 * 目前只有英雄 - 冷却上限用到了
 */
export const GameParamLinkIdMap = {
  [3]: 21,
  [31]: 47,
  [54]: 91,
  [59]: 92,
  [64]: 93,
  [69]: 94,
  [74]: 95,
  [79]: 96,
  [84]: 97,
  [89]: 98,
};

/**
 * 英雄 - 初始等级
 */
export const GameParamInitialLevel = {
  one: { value: GAME_PARAM_DEFAULT_VALUE, label: '1级' },
  four: { value: 1, label: '4级' },
  five: { value: 2, label: '5级' },
  eight: { value: 3, label: '8级' },
  ten: { value: 4, label: '10级' },
  twelve: { value: 5, label: '12级' },
  fifteen: { value: 6, label: '15级' },
};

/**
 * 英雄 - 法术攻击加成
 */
export const GameParamMagicAttackBonus = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

/**
 * 英雄 - 物理攻击加成
 */
export const GameParamPhysicalAttackBonus = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

/**
 * 英雄 - 初始金币
 */
export const GameParamInitialGold = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  one: { value: 1, label: '1000' },
  two: { value: 2, label: '2000' },
  five: { value: 3, label: '5000' },
  twelve: { value: 4, label: '12000' },
};

/**
 * 英雄 - 移速
 */
export const GameParamSpeed = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twenty: { value: 2, label: '加20%' },
  thirty: { value: 3, label: '加30%' },
};

/**
 * 英雄 - 冷却缩减
 */
export const GameParamCooldownReduction = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '减25%' },
  forty: { value: 2, label: '减40%' },
  eighty: { value: 3, label: '减80%' },
  ninetyNine: { value: 4, label: '减99%' },
};

const defaultGameParamHero = [
  { key: GameParamKey.hero.initialLevel, label: '初始等级', value: GameParamInitialLevel.one, options: Object.values(GameParamInitialLevel) },
  { key: GameParamKey.hero.magicAttackBonus, label: '法术攻击加成', value: GameParamMagicAttackBonus.none, options: Object.values(GameParamMagicAttackBonus) },
  { key: GameParamKey.hero.physicalAttackBonus, label: '物理攻击加成', value: GameParamPhysicalAttackBonus.none, options: Object.values(GameParamPhysicalAttackBonus) },
  { key: GameParamKey.hero.cooldownReduction, label: '冷却缩减', value: GameParamCooldownReduction.none, options: Object.values(GameParamCooldownReduction) },
  { key: GameParamKey.hero.initialGold, label: '初始金币', value: GameParamInitialGold.none, options: Object.values(GameParamInitialGold) },
  { key: GameParamKey.hero.speed, label: '移速', value: GameParamSpeed.none, options: Object.values(GameParamSpeed) },
];

const defaultGameParamHeroGlobal = [
  {
    subtitle: '英雄', // 英雄属性、红方英雄属性、蓝方英雄属性
    active: 0, // 当前选中的选手，统一设置、按阵营设置时为0
    formItemArray: [deepCopy(defaultGameParamHero)],
  },
];

/**
 * 英雄 - 全局统一默认配置
 */
export function newDefaultGameParamHeroGlobal() {
  return deepCopy(defaultGameParamHeroGlobal);
}

export const defaultGameParamHeroFaction = [
  {
    subtitle: '蓝方英雄属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamHero)],
  },
  {
    subtitle: '红方英雄属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamHero)],
  },
];

/**
 * 英雄 - 按阵营默认配置
 */
export function newDefaultGameParamHeroFaction() {
  return deepCopy(defaultGameParamHeroFaction);
}

export const defaultGameParamHeroPlayer = [
  {
    subtitle: '蓝方英雄属性',
    active: 0,
    contestant: ['1号', '2号', '3号', '4号', '5号'],
    formItemArray: [
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
    ],
  },
  {
    subtitle: '红方英雄属性',
    active: 0,
    contestant: ['1号', '2号', '3号', '4号', '5号'],
    formItemArray: [
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
      deepCopy(defaultGameParamHero),
    ],
  },
];

/**
 * 英雄 - 按选手默认配置
 */
export function newDefaultGameParamHeroPlayer() {
  return deepCopy(defaultGameParamHeroPlayer);
}


/**
 * 兵线 - 攻击力
 */
export const GameParamCreepAttack = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

/**
 * 兵线 - 血量
 */
export const GameParamCreepHealth = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

/**
 * 兵线 - 移动速度
 */
export const GameParamCreepSpeed = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
  oneHundred: { value: 3, label: '加100%' },
};

/**
 * 兵线 - 刷新速度
 */
export const GameParamCreepSpawnRate = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  five: { value: 1, label: '加5%' },
  ten: { value: 2, label: '加10%' },
  fifteen: { value: 3, label: '加15%' },
};

/**
 * 兵线 - 出兵类型
 */
export const GameParamCreepType = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '普通兵线' },
  five: { value: 1, label: '超级兵' },
  ten: { value: 2, label: '主宰先锋' },
};

/**
 * 兵线 - 出兵路线
 */
export const GameParamCreepPath = {
  top: { value: 1, label: '对抗路' },
  mid: { value: 2, label: '中路' },
  bottom: { value: 4, label: '发育路' },
};

const defaultGameParamCreep = [
  { key: GameParamKey.creep.creepAttack, label: '攻击力', value: GameParamCreepAttack.none, options: Object.values(GameParamCreepAttack) },
  { key: GameParamKey.creep.creepHealth, label: '血量', value: GameParamCreepHealth.none, options: Object.values(GameParamCreepHealth) },
  { key: GameParamKey.creep.creepSpeed, label: '移动速度', value: GameParamCreepSpeed.none, options: Object.values(GameParamCreepSpeed) },
  { key: GameParamKey.creep.creepSpawnRate, label: '刷新速度', value: GameParamCreepSpawnRate.none, options: Object.values(GameParamCreepSpawnRate) },
  { key: GameParamKey.creep.creepType, label: '出兵类型', value: GameParamCreepType.none, options: Object.values(GameParamCreepType) },
  {
    key: GameParamKey.creep.creepPath, label: '出兵路线',
    value: {
      paths: [GameParamCreepPath.top, GameParamCreepPath.mid, GameParamCreepPath.bottom],
      label: [GameParamCreepPath.top, GameParamCreepPath.mid, GameParamCreepPath.bottom].map(item => item.label).join('、'),
    },
    options: Object.values(GameParamCreepPath),
  },
];

/**
 * 兵线默认配置
 */
export function newDefaultGameParamCreep() {
  return [deepCopy(defaultGameParamCreep)];
}

export const defaultGameParamCreepGlobal = [
  {
    subtitle: '兵线',
    active: 0,
    formItemArray: newDefaultGameParamCreep(),
  },
];

/**
 * 兵线 - 按全局配置
 */
export function newDefaultGameParamCreepGlobal() {
  return deepCopy(defaultGameParamCreepGlobal);
}

export const defaultGameParamCreepFaction = [
  {
    subtitle: '蓝方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamCreep)],
  },
  {
    subtitle: '红方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamCreep)],
  },
];

/**
 * 兵线 - 按阵营配置
 */
export function newDefaultGameParamCreepFaction() {
  return deepCopy(defaultGameParamCreepFaction);
}

/**
 * 野怪 - 攻击力
 */
export const GameParamMonsterAttack = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

/**
 * 野怪 - 血量
 */
export const GameParamMonsterHealth = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  ten: { value: 1, label: '加10%' },
  twentyFive: { value: 2, label: '加25%' },
  fifty: { value: 3, label: '加50%' },
  seventyFive: { value: 4, label: '加75%' },
  oneHundred: { value: 5, label: '加100%' },
};

const defaultGameParamMonster = [
  { key: GameParamKey.monster.monsterAttack, label: '攻击力', value: GameParamMonsterAttack.none, options: Object.values(GameParamMonsterAttack) },
  { key: GameParamKey.monster.monsterHealth, label: '血量', value: GameParamMonsterHealth.none, options: Object.values(GameParamMonsterHealth) },
];

/**
 * 野怪默认配置
 */
export function newDefaultGameParamMonster() {
  return [deepCopy(defaultGameParamMonster)];
}

export const defaultGameParamMonsterGlobal = [
  {
    subtitle: '野怪',
    active: 0,
    formItemArray: newDefaultGameParamMonster(),
  },
];

/**
 * 野怪 - 按全局配置
 */
export function newDefaultGameParamMonsterGlobal() {
  return deepCopy(defaultGameParamMonsterGlobal);
}

export const defaultGameParamMonsterFaction = [
  {
    subtitle: '蓝方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamMonster)],
  },
  {
    subtitle: '红方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamMonster)],
  },
];

/**
 * 野怪 - 按阵营配置
 */
export function newDefaultGameParamMonsterFaction() {
  return deepCopy(defaultGameParamMonsterFaction);
}

/**
 * 防御塔 - 攻击力
 */
export const GameParamTowerAttack = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
  oneHundred: { value: 3, label: '加100%' },
};

/**
 * 防御塔 - 攻击范围
 */
export const GameParamTowerAttackRange = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
};

/**
 * 防御塔 - 血量
 */
export const GameParamTowerHealth = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
  oneHundred: { value: 3, label: '加100%' },
};

const defaultGameParamTower = [
  { key: GameParamKey.tower.towerAttack, label: '攻击力', value: GameParamTowerAttack.none, options: Object.values(GameParamTowerAttack) },
  { key: GameParamKey.tower.towerAttackRange, label: '攻击范围', value: GameParamTowerAttackRange.none, options: Object.values(GameParamTowerAttackRange) },
  { key: GameParamKey.tower.towerHealth, label: '血量', value: GameParamTowerHealth.none, options: Object.values(GameParamTowerHealth) },
];

/**
 * 防御塔默认配置
 */
export function newDefaultGameParamTower() {
  return [deepCopy(defaultGameParamTower)];
}

export const defaultGameParamTowerGlobal = [
  {
    subtitle: '防御塔',
    active: 0,
    formItemArray: newDefaultGameParamTower(),
  },
];

/**
 * 防御塔 - 按全局配置
 */
export function newDefaultGameParamTowerGlobal() {
  return deepCopy(defaultGameParamTowerGlobal);
}

export const defaultGameParamTowerFaction = [
  {
    subtitle: '蓝方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamTower)],
  },
  {
    subtitle: '红方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamTower)],
  },
];

/**
 * 防御塔 - 按阵营配置
 */
export function newDefaultGameParamTowerFaction() {
  return deepCopy(defaultGameParamTowerFaction);
}

/**
 * 水晶 - 攻击力
 */
export const GameParamCrystalAttack = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
  oneHundred: { value: 3, label: '加100%' },
};

/**
 * 水晶 - 血量
 */
export const GameParamCrystalHealth = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  twentyFive: { value: 1, label: '加25%' },
  fifty: { value: 2, label: '加50%' },
  oneHundred: { value: 3, label: '加100%' },
};

/**
 * 水晶 - 护甲
 */
export const GameParamCrystalArmor = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '无加成' },
  oneHundred: { value: 1, label: '加100%' },
};

const defaultGameParamCrystal = [
  { key: GameParamKey.crystal.crystalAttack, label: '攻击力', value: GameParamCrystalAttack.none, options: Object.values(GameParamCrystalAttack) },
  { key: GameParamKey.crystal.crystalHealth, label: '血量', value: GameParamCrystalHealth.none, options: Object.values(GameParamCrystalHealth) },
];

/**
 * 水晶 - 护甲
 */
export const GameParamWinCondition = {
  none: { value: GAME_PARAM_DEFAULT_VALUE, label: '摧毁水晶' },
  towerFirst: { value: 1, label: '摧毁任意一个一塔' },
  towerSecond: { value: 2, label: '摧毁任意一个二塔' },
  towerThird: { value: 3, label: '摧毁任意一个三塔' },
  killOne: { value: 4, label: '1个总击败' },
  killThree: { value: 5, label: '3个总击败' },
  killFive: { value: 6, label: '5个总击败' },
  killTen: { value: 7, label: '10个总击败' },
  killTwenty: { value: 8, label: '20个总击败' },
  killThirty: { value: 9, label: '30个总击败' },
  killForty: { value: 10, label: '40个总击败' },
  assistOne: { value: 11, label: '1个总助攻' },
  assistThree: { value: 12, label: '3个总助攻' },
  assistFive: { value: 13, label: '5个总助攻' },
  assistTen: { value: 14, label: '10个总助攻' },
  asisstTwenty: { value: 15, label: '20个总助攻' },
  assistThirty: { value: 16, label: '30个总助攻' },
  assistForty: { value: 17, label: '40个总助攻' },
};

/**
 * 水晶默认配置
 */
export function newDefaultGameParamCrystal() {
  return [deepCopy(defaultGameParamCrystal)];
}


export const defaultGameParamCrystalGlobal = [
  {
    subtitle: '水晶',
    active: 0,
    formItemArray: newDefaultGameParamCrystal(),
  },
];

/**
 * 水晶 - 按全局配置
 */
export function newDefaultGameParamCrystalGlobal() {
  return deepCopy(defaultGameParamCrystalGlobal);
}

export const defaultGameParamCrystalFaction = [
  {
    subtitle: '蓝方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamCrystal)],
  },
  {
    subtitle: '红方阵营属性',
    active: 0,
    formItemArray: [deepCopy(defaultGameParamCrystal)],
  },
];

/**
 * 水晶 - 按阵营配置
 */
export function newDefaultGameParamCrystalFaction() {
  return deepCopy(defaultGameParamCrystalFaction);
}

const defaultGameParamWinCondition = { key: GameParamKey.winCondition.winCondition, label: '胜利条件', value: GameParamWinCondition.none, options: Object.values(GameParamWinCondition) };

/**
 * 胜利条件默认配置
 */
export function newDefaultGameParamWinCondition() {
  return deepCopy(defaultGameParamWinCondition);
}

/**
 * 游戏参数默认配置
 */
const defaultGameParam = [
  {
    title: '英雄',
    key: 'heroAttribute',
    configType: GAME_PARAM_HERO_CONFIG_TYPE.global,
    children: newDefaultGameParamHeroGlobal(),
  },
  {
    title: '兵线',
    key: 'creepAttribute',
    configType: GAME_PARAM_NORMAL_CONFIG_TYPE.global,
    children: newDefaultGameParamCreepGlobal(),
  },
  {
    title: '野怪',
    key: 'monsterAttribute',
    configType: GAME_PARAM_NORMAL_CONFIG_TYPE.global,
    children: newDefaultGameParamMonsterGlobal(),
  },
  {
    title: '防御塔',
    key: 'towerAttribute',
    configType: GAME_PARAM_NORMAL_CONFIG_TYPE.global,
    children: newDefaultGameParamTowerGlobal(),
  },
  {
    title: '水晶',
    key: 'crystalAttribute',
    configType: GAME_PARAM_NORMAL_CONFIG_TYPE.global,
    children: newDefaultGameParamCrystalGlobal(),
  },
];

export function newDefaultGameParam() {
  return deepCopy(defaultGameParam);
}

export function countBytes(str) {
  if (typeof str !== 'string') {
    return 0;
  }
  let num = 0;
  const re = /[\u4e00-\u9fa5]/;
  for (let i = 0;i < str.length;i++) {
    if (re.test(str[i])) {
      num = num + 2;
    } else {
      num = num + 1;
    }
  }
  return num;
}


export const GAME_PARAM_DETAIL_DESC =  {
  [GameParamMode.GameParamModeCold]: {
    desc: '开局1级、初始金币300、冷却缩减+80%',
  },
  [GameParamMode.GameParamModeSeckill]: {
    desc: '开局5级、初始金币5000、物理/法术攻击+100%、冷却缩减+80%、小兵攻击/血量+100%、野怪攻击/血量+100%、水晶攻击/血量+100%、防御塔攻击/血量+100%',
  },
  [GameParamMode.GameParamModeSurvival]: {
    desc: '开局1级、初始金币300、防御塔攻击/血量+100%、防御塔攻击范围+50%、野怪攻击/血量+100%、团队击败30人胜利',
  },
  [GameParamMode.GameParamModeMaxed]: {
    desc: '开局15级、初始金币12000',
  },
  [GameParamMode.GameParamModeCustom]: {
    desc: '自定义',
  },
  [GameParamMode.GameParamModeRandom]: {
    desc: '随机抽卡',
  },
};
